import { useCallback, useEffect, useMemo, useState } from "react";
import { CasAuthApi, CasProfileApi, CasPurposesApi, getUser } from "@jti/rest-api";
const checkLoggedIn = async (user) => {
    if (!user?.ciam_token) {
        return false;
    }
    try {
        const { statusCode } = await CasAuthApi.init().validate(user.ciam_token, true);
        return statusCode === 200;
    }
    catch (e) {
        console.error("checkLoggedIn error ==>", e);
        return false;
    }
};
const checkAgeVerified = async (user) => {
    if (!user?.ciam_token) {
        return false;
    }
    try {
        const { is_age_verified } = await CasProfileApi.init().getProfile(true);
        return is_age_verified;
    }
    catch (e) {
        console.error("checkAgeVerified error ==>", e);
        return false;
    }
};
const checkPurpose = async (purposeId) => {
    try {
        const purposes = await CasPurposesApi.init().getPurposesForUserByCategory("all", true);
        const matchedPurpose = purposes.find((purpose) => purpose.id === purposeId);
        return matchedPurpose ? matchedPurpose.accepted : false;
    }
    catch (e) {
        console.error("checkPurpose error ==>", e);
        return false;
    }
};
export const useContentGateRestrictions = (restrictions) => {
    const [activeRestrictions, setActiveRestrictions] = useState([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const checkRestrictions = useCallback(async () => {
        const user = getUser();
        const active = [];
        const isLoggedIn = await checkLoggedIn(user);
        const isAgeVerified = await checkAgeVerified(user);
        const isDeviceRegistered = user?.is_device_registered || false;
        for (const restriction of restrictions) {
            switch (restriction.type) {
                case "LOGGED_IN":
                    if (!isLoggedIn)
                        active.push(restriction);
                    break;
                case "AGE_VERIFIED":
                    if (!isAgeVerified)
                        active.push(restriction);
                    break;
                case "DEVICE_REGISTRATION":
                    if (!isDeviceRegistered)
                        active.push(restriction);
                    break;
                case "PURPOSE":
                    if (!(await checkPurpose(restriction.purposeId)))
                        active.push(restriction);
                    break;
            }
        }
        setActiveRestrictions(active);
        setIsDialogOpen(active.length > 0);
    }, [restrictions]);
    useEffect(() => {
        checkRestrictions();
    }, [checkRestrictions]);
    const modifiedActiveRestrictions = useMemo(() => {
        const currentPageUrl = window.location.href;
        return activeRestrictions.map((restriction) => {
            if (restriction.type === "LOGGED_IN") {
                let updatedLink = `${restriction.link}#/login`;
                updatedLink += `?returnUrl=${encodeURIComponent(currentPageUrl)}`;
                return { ...restriction, link: updatedLink };
            }
            return restriction;
        });
    }, [activeRestrictions]);
    return { activeRestrictions: modifiedActiveRestrictions, isDialogOpen };
};
//# sourceMappingURL=useContentGateRestrictions.js.map